import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import supplierService from "../Services/supplierService";
import DeleteModal from "../Components/DeleteModal";
import Loading from "../Modals/Loading";
import { HiOutlineTrash } from "react-icons/hi";
import { IoDocumentTextOutline } from "react-icons/io5";
import Head from "../Components/Head";

const Suppliers = () => {
  const [data, setData] = useState([]);
  const [deleteID, setDeleteID] = useState();
  const [deleting, setDeleting] = useState(false);
  const [open, setOpen] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [loading, setLoading] = useState(false);

  const initiateDelete = (id) => {
    setOpen(!open);
    setDeleteID(id);
  };
  const handleDelete = () => {
    setDeleting(true);
    supplierService.delete(deleteID).then((res) => {
      setDeleting(false);
      setTrigger(!trigger);
    });
  };

  useEffect(() => {
    const getSuppliers = async () => {
      await supplierService.fetchAll().then((res) => {
        setData(res.suppliers);
      });
    };
    getSuppliers();
  }, [trigger]);

  useEffect(() => {
    const getSupplier = async () => {
      try {
        setLoading(true);
        const response = await supplierService.fetchAll();
        setData(response.suppliers);
        setLoading(false);
      } catch (error) {}
    };
    getSupplier();
  }, [trigger]);

  const navigate = useNavigate();
  return (
    <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      {loading ? (
        <div className="">
          <Loading />
        </div>
      ) : (
        <>
          <DeleteModal
            open={open}
            setOpen={setOpen}
            deleteFunction={handleDelete}
            deleting={deleting}
          />
          <Head
            heading={"Suppliers"}
            button_text={"Add Supplier"}
            navigation={() => navigate("/suppliers/add")}
          />
          <div className="table-div">
            <table>
              <thead>
                <tr className="border-y-2 text-left w-full text-black text-[10px]">
                  <th className="py-4 w-[1%] pl-4 font-semibold">Sr No.</th>
                  <th className="py-4 w-[6%] font-semibold">Company</th>
                  <th className="py-4 w-[3%] font-semibold">Country</th>
                  <th className="py-4 w-[1%] font-semibold text-center">
                    Ledger
                  </th>
                  <th className="py-4w-[1%] font-semibold text-center">
                    Delete
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.map((value, index) => (
                  <tr
                    key={index}
                    className="bg-accent border-b border-gray-100 text-left"
                  >
                    <td className="py-4 w-[1%] pl-4 font-bold text-blue-500">
                      {index + 1}.
                    </td>
                    <td className="py-4 w-[6%] font-semibold">
                      {value.company}
                    </td>
                    <td className="py-4 w-[3%]">
                      {value.country.toUpperCase()}
                    </td>
                    <td className="py-4 w-[1%] text-center">
                      <button
                        onClick={() =>
                          navigate(`/suppliers/ledger?id=${value.id}`)
                        }
                      >
                        <IoDocumentTextOutline className="h-4 w-4 text-amber-500" />
                      </button>
                    </td>
                    <td className="py-2 w-[1%] text-center">
                      <button onClick={() => initiateDelete(value.id)}>
                        <HiOutlineTrash className="h-4 w-4 text-red-500" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default Suppliers;
